import { VideoOwnerToolbar } from './video_channel_toolbar';
import Alpine from 'alpinejs';

Alpine.data('videoOwnerToolbar', () => new VideoOwnerToolbar());
